<template>
  
</template>

<script>
  export default {
    name: "approvalTimeRange"
  }
</script>

<style scoped>

</style>